module.exports = __webpack_public_path__ + "img/newplay.1a495d81.svg";